import { useCallback, useLayoutEffect, useRef } from 'react';

const TOP_THRESHOLD = 24;
const BOTTOM_THRESHOLD = 24;

const getScrollRegion = (el) => {
  const { scrollTop, scrollHeight, clientHeight } = el;

  const nearTop = scrollTop <= TOP_THRESHOLD;
  const nearBottom = scrollTop + clientHeight >= scrollHeight - BOTTOM_THRESHOLD;

  if (nearBottom) return 'bottom';
  if (nearTop) return 'top';
  return 'middle';
};

const useChatScrollTracking = ({ track, isAutoScrollingRef, scrollContainerRef }) => {
  const lastRegionRef = useRef('middle');

  useLayoutEffect(() => {
    const el = scrollContainerRef?.current;
    if (!el) return;

    lastRegionRef.current = getScrollRegion(el);
  }, [scrollContainerRef]);

  return useCallback((event) => {
    if (isAutoScrollingRef.current) return;

    const region = getScrollRegion(event.currentTarget);

    if (region === 'middle') return;
    if (region === lastRegionRef.current) return;

    lastRegionRef.current = region;

    if (region === 'top') {
      track({
        event: {
          identifier: 'axp - WishlistBuilder - Chat',
          element: 'ScrollTop',
          type: 'scroll',
        },
      });
    }

    if (region === 'bottom') {
      track({
        event: {
          identifier: 'axp - WishlistBuilder - Chat',
          element: 'ScrollBottom',
          type: 'scroll',
        },
      });
    }
  }, [track, isAutoScrollingRef]);
};

export default useChatScrollTracking;
